import { IsomorphicPersistent } from '@hit/amorphic-types';
import { property, supertypeClass } from '@haventech/amorphic';
import { BaseQuote } from './BaseQuote';
import { RiderType } from '../static/Product';

@supertypeClass({ toClient: true, toServer: true })
export class QuoteRider extends IsomorphicPersistent {
  @property()
  type: RiderType;

  @property()
  amount: number;

  @property()
  premiumBase: number;

  @property()
  premiumWaiver: number;

  @property({
    getType: () => BaseQuote,
    comment: 'Quote to which this rider is attached.',
  })
  quote: BaseQuote;

  @property({
    comment: 'Planned years additional life insurance is purchased for',
  })
  plannedYears: number;

  @property({
    comment: 'ALIR Payment Frequency',
  })
  paymentFrequency: string;

  @property({
    comment: 'Has ALIR Scheduled Payments',
  })
  hasScheduledPayments: boolean;

  @property({
    comment: 'CIR Payout method',
  })
  benefitDisbursementMethod: number;

  @property({
    comment: 'Predicted age the insured begins taking the CIR benefit',
  })
  predictedBenefitAge: number;

  @property({
    comment: 'Include PUA in CIR benefit pool',
  })
  puaAddedToBenefitPool: boolean;

  @property({
    comment: 'Usage of PUA in the CIR benefit pool',
  })
  monthlyIncreaseOption: boolean;

  constructor() {
    super();
  }

  static new(type: RiderType, quote: BaseQuote) {
    return new QuoteRider().init(type, quote);
  }

  init(type: RiderType, quote: BaseQuote) {
    this.type = type;
    this.quote = quote;
    return this;
  }
}
